<template>
  <div class="rich-card" tabindex="0" :style="{ height, width }">
    <a
        class="rich-list-item-content rich-card-item-link"
        target="_self"
        rel="noopener noreferrer">
      <img v-if="imageUri" class="rich-card-image" :src="imageUri" :alt="imageTitle" width="100px">
      <div class="rich-card-content">
        <div v-if="title" class="rich-card-title"><VueMarkdown :source="title" /></div>
        <div v-if="subtitle" class="rich-card-subtitle"><VueMarkdown :source="subtitle" /></div>
        <div v-if="text" class="rich-card-text"><VueMarkdown :source="text" /></div>
        <div :class="{'rich-card-actions': $slots.default}">
          <slot />
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-render'

export default {
  name: 'RichCard',
  components: { VueMarkdown },
  props: {
    text: {
      type: String,
      default: null
    },
    imageUri: {
      type: String,
      default: null
    },
    imageTitle: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: '100px'
    },
    height: {
      type: String,
      default: '50px'
    }
  }
}
</script>

<style lang="sass" scoped>
.rich-card
  background-color: var(--background-component)
  box-shadow: var(--shadow)
  border-radius: 12px

.rich-card-item-link
  text-decoration: none
  pointer-events: none

.rich-card-image
  width: 100%
  height: auto
  object-fit: cover
  border-top-right-radius: 10px
  border-top-left-radius: 10px
  background-color: var(--background-image)

.rich-card-content
  padding: 10px 14px

.rich-card-title
  font-size: 12px
  color: var(--text-title)
  line-height: 20px
  overflow: hidden
  text-overflow: ellipsis
  :deep(p)
    margin: 0 !important
    line-height: 20px
    font-size: 12px

.rich-card-subtitle
  font-size: 14px
  line-height: 20px
  color: var(--text-subtitle)

.rich-card-text
  line-height: 18px
  font-size: 12px
  color: var(--text-secondary)
  white-space: normal

.rich-card-actions
  display: flex
  pointer-events: auto
</style>
